@for (radio of radios$ | async; track radio.title) {
  <app-onboarding-consent class="mb-16" [radio]="radio"></app-onboarding-consent>
}
